// The layout sets `html { scroll-behavior: smooth }` for in-page anchors. It
// also turns Turbo's scroll to the top after a visit into an animation through
// the whole new page — two seconds from a footer link — and any wheel, touch
// or leftover trackpad momentum stops it halfway down. Jump instantly while
// Turbo renders and positions the page, then hand smooth scrolling back.
const root = document.documentElement

function scrollInstantly() {
  root.style.scrollBehavior = "auto"
}

function restoreScrollBehavior() {
  requestAnimationFrame(() => root.style.removeProperty("scroll-behavior"))
}

document.addEventListener("turbo:before-render", scrollInstantly)
document.addEventListener("turbo:load", restoreScrollBehavior)
